import { getLaborLawFines } from 'lib/api/business';
import LaborLawFinesTable from 'lib/common/Tables/LaborLawFinesTable';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import React from 'react';
import { useDispatch } from 'react-redux';

type LaborLawFinesTabProps = {
  identifier?: string;
};

function LaborLawFinesTab({ identifier }: LaborLawFinesTabProps) {
  if (!identifier) return;
  const dispatch = useDispatch();
  const { data: consult, isPending: loading } = getLaborLawFines(
    dispatch,
    identifier,
  );

  if (loading) return <CenteredCircularProgress relative />;

  return (
    <div>
      <HeaderWithActions variant="h6" subHeader buttons={[]} title="" />
      <LaborLawFinesTable consult={consult} />
    </div>
  );
}

export default LaborLawFinesTab;
